import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CheckoutActions } from "../actions";
import { ApiService } from "../../../../SGRE-shared/services/api.service";
import { switchMap, map, catchError, of, takeUntil } from "rxjs";
import { LoggerService, tryNormalizeHttpError } from "@spartacus/core";
import { CheckoutCartGroup } from "../../models/checkout.model";
import { GlobalService } from "../../../../SGRE-shared/services/global.service";

@Injectable()
export class CheckoutBillingAddressEffects {

    protected logger = inject(LoggerService);

    constructor(
        private actions$: Actions,
        private apiService: ApiService,
        private globalService: GlobalService
    ) { }

    loadBillingAddressApprove$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CheckoutActions.loadBillingAddressApprove),
            switchMap(({ cartGroupId }) =>
                this.apiService.cartgroupOrder(cartGroupId)
                    .pipe(
                        takeUntil(this.actions$.pipe(ofType(CheckoutActions.clearCheckoutState))),
                        map((data: CheckoutCartGroup) => CheckoutActions.loadBillingAddressApproveSuccess({ payload: data })),
                        catchError(error => {
                            this.globalService.loadingSubject.next(false);
                            return of(CheckoutActions.loadBillingAddressApproveFail({
                                payload: tryNormalizeHttpError(error, this.logger)
                            }));
                        })
                    )
            ),
        )
    );
}